import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FeatureToggleService } from '@farmnet/fnx-components';
import { deleteCookie } from '../../../app/helper/cookie';
import { LogoutUrlResponse } from './logout-url.interface';

declare global {
  const app: any;
}

const authUrl = '/365FarmNet/rest/user';

@Injectable()
export class LoginService {
  constructor(
    private featureToggleService: FeatureToggleService,
    private http: HttpClient,
    @Inject('$rootScope') private $rootScope: any
  ) {}

  authenticate = (user: { username: string; password: string }) => {
    const data = new HttpParams()
      .set('username', user.username)
      .set('password', encodeURIComponent(user.password));

    return this.http
      .post(`${authUrl}/authenticate`, data.toString(), {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
      })
      .toPromise();
  };

  logoutAndCleanup = async () => {
    const logoutUrl = await this.getLogoutUrl();

    return this.http
      .post(`${authUrl}/logout`, null)
      .toPromise()
      .then(credentials => {
        deleteCookie('currentCalenderViewName');
        deleteCookie('hideDemoAccountOverlay');
        this.$rootScope.credentials = credentials;

        parent.location.href = logoutUrl;
      });
  };

  private getLogoutUrl = async (): Promise<string> => {
    let partnerId = '365farmnet';
    let logoutUrl = '/signon/';

    if (app.credentials.userProperties['com.365farmnet.partner.id']) {
      partnerId = app.credentials.userProperties['com.365farmnet.partner.id'];
    }

    if (partnerId !== '365farmnet') {
      await this.getPartnerLogoutUrl(partnerId)
        .then((response: LogoutUrlResponse) => {
          console.log(
            'Connect partner logout URL response:',
            JSON.stringify(response)
          );
          logoutUrl = response.data.logoutUrl;
        })
        .catch(error => {
          console.error(
            `[${error.name}] Error getting the Connect partner log out URL: ${
              error.message
            }`
          );
          logoutUrl = '/signon/logout';
        });
    }

    return logoutUrl;
  };

  private getPartnerLogoutUrl = (partnerId: string) => {
    return this.http
      .get(
        `/365FarmNet/mod/partner-service/v1.0/partners/${partnerId}/logout-url`
      )
      .toPromise();
  };
}
